// @flow
import {
  ACCOUNTS_UPDATED,
  ACCOUNTS_UPDATING,
  ACCOUNTS_FETCH_ERROR,
  ACCOUNTS_EMPTY_ERROR,
  PROPERTIES_UPDATED,
  PROPERTIES_UPDATING,
  PROPERTIES_FETCH_ERROR,
  PROPERTIES_CREATING,
  PROPERTIES_CREATED,
  SUMMARY_UPDATED,
  SUMMARY_UPDATING,
  SUMMARY_EMPTY_ERROR,
  SUMMARY_FETCH_ERROR,
  OPEN_REMOVE_PROJECT_DIALOG,
  CLOSE_REMOVE_PROJECT_DIALOG,
  OPEN_DISABLE_PROJECT_DIALOG,
  CLOSE_DISABLE_PROJECT_DIALOG,
  GA_SAVED,
  GA_SAVING,
  DIMENSIONS_UPDATED,
  DIMENSIONS_UPDATING,
  PROJECT_SETTING_UP,
  PROJECT_SETTING_UP_DONE,
  SOURCE_CODE_RECEIVE_START,
  SOURCE_CODE_RECEIVED,
  OPEN_WORKSPACE_DONE_DIALOG,
  CLOSE_WORKSPACE_DONE_DIALOG,
  OPEN_VERSION_DONE_DIALOG,
  CLOSE_VERSION_DONE_DIALOG
} from '../actions/project.actions';

const initialState = {
  accountsUpdating: false,
  accountsError: null,
  webPropertiesUpdating: false,
  webPropertiesCreating: false,
  webPropertiesError: null,
  showRemoveDialog: false,
  removeProjectId: null,
  accounts: [],
  webProperties: [],
  dimensions: [],
  dimensionsUpdating: false,
  gaSaving: false,
  projectSettingUp: false,
  showVersionDoneDialog: false,
  showWorkspaceDoneDialog: false
};

export default (state: Object = initialState, action: { type: String, data: Object }) => {
  switch (action.type) {
    case DIMENSIONS_UPDATED:
      return {
        ...state,
        dimensions: action.data,
        dimensionsUpdating: false
      };
    case DIMENSIONS_UPDATING:
      return {
        ...state,
        dimensions: [],
        dimensionsUpdating: true
      };
    case GA_SAVED:
      return {
        ...state,
        gaSaving: false
      };
    case GA_SAVING:
      return {
        ...state,
        gaSaving: true
      };
    case PROJECT_SETTING_UP:
      return {
        ...state,
        projectSettingUp: true
      };
    case PROJECT_SETTING_UP_DONE:
      return {
        ...state,
        projectSettingUp: false
      };
    case SUMMARY_UPDATED:
      return {
        ...state,
        accounts: action.data,
        webProperties: [],
        accountsError: null,
        accountsEmptyError: false,
        accountsUpdating: false
      };
    case SUMMARY_UPDATING:
      return {
        ...state,
        accounts: [],
        webProperties: [],
        accountsError: null,
        accountsEmptyError: false,
        accountsUpdating: true
      };
    case SUMMARY_FETCH_ERROR:
      return {
        ...state,
        accounts: [],
        accountsError: true,
        accountsEmptyError: false,
        accountsUpdating: false
      };
    case SUMMARY_EMPTY_ERROR:
      return {
        ...state,
        accounts: [],
        accountsEmptyError: true,
        accountsError: null,
        accountsUpdating: false
      };
    case ACCOUNTS_UPDATING:
      return {
        ...state,
        accounts: [],
        accountsError: null,
        accountsUpdating: true
      };
    case ACCOUNTS_FETCH_ERROR:
      return {
        ...state,
        ...action.data,
        accountsError: true,
        accountsEmptyError: false,
        accountsUpdating: false
      };
    case ACCOUNTS_EMPTY_ERROR:
      return {
        ...state,
        ...action.data,
        accountsEmptyError: null,
        accountsError: false,
        accountsUpdating: false
      };
    case ACCOUNTS_UPDATED:
      return {
        ...state,
        accounts: action.data,
        accountsEmptyError: null,
        accountsError: null,
        accountsUpdating: false
      };
    case PROPERTIES_UPDATING:
      return {
        ...state,
        webProperties: [],
        webPropertiesError: null,
        webPropertiesUpdating: true
      };
    case PROPERTIES_FETCH_ERROR:
      return {
        ...state,
        webPropertiesUpdating: false,
        webPropertiesError: true
      };
    case PROPERTIES_UPDATED:
      return {
        ...state,
        webProperties: action.data,
        webPropertiesError: null,
        webPropertiesUpdating: false
      };
    case PROPERTIES_CREATING:
      return {
        ...state,
        webPropertiesCreating: true
      };
    case PROPERTIES_CREATED:
      return {
        ...state,
        webPropertiesCreating: false
      };

    case SOURCE_CODE_RECEIVE_START:
      return {
        ...state,
        sourceCodeIsLoading: true
      };

    case SOURCE_CODE_RECEIVED:
      return {
        ...state,
        sourceCodeIsLoading: false,
        sourceOfTag: {
          id: action.data.id,
          tag: action.data.tag
        }
      };

    case OPEN_REMOVE_PROJECT_DIALOG:
      return {
        ...state,
        showRemoveDialog: true,
        removeProjectId: action.data
      };

    case CLOSE_REMOVE_PROJECT_DIALOG:
      return {
        ...state,
        showRemoveDialog: false,
        removeProjectId: null
      };

    case OPEN_DISABLE_PROJECT_DIALOG:
      return {
        ...state,
        showDisableDialog: true,
        disableProjectId: action.data
      };

    case CLOSE_DISABLE_PROJECT_DIALOG:
      return {
        ...state,
        showDisableDialog: false,
        disableProjectId: null
      };

    case OPEN_WORKSPACE_DONE_DIALOG:
      return {
        ...state,
        showWorkspaceDoneDialog: action.data
      };

    case CLOSE_WORKSPACE_DONE_DIALOG:
      return {
        ...state,
        showWorkspaceDoneDialog: false
      };

    case OPEN_VERSION_DONE_DIALOG:
      return {
        ...state,
        showVersionDoneDialog: action.data
      };

    case CLOSE_VERSION_DONE_DIALOG:
      return {
        ...state,
        showVersionDoneDialog: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/projectReducer.js